import React from 'react';
import personImage from '../../assets/Person.jpg';
// import SaurabhSengupta from '../../assets/Saurabh.jpg';
import teamMeena from '../../assets/Meena.jpg';
import teamJayKumarYadav from '../../assets/Jay Kumar Yadav.jpg';
import teamNavdeepKaur from '../../assets/Navdeep Kaur.jpg';
import rahul from '../../assets/rahul.jpeg';
import arundhati from '../../assets/Arundhati Sengupta.jpg';
import advocateGCSingh from '../../assets/GCSINGH.png';
import JOYOSHREE_ARORA from '../../assets/JOYOSHREE ARORA.jpeg';
import teamSubrato from '../../assets/SUBRATO.jpeg';
import EntertainmentHead from '../../assets/EntertainmentHead.jpeg';

const teamMembers = [
  {
    name: 'Saurabh Sengupta',
    designation: 'Creator',
    bio: 'Younger son of Dr. Sushma Sengupta, being a Writer-Director in advertising, television and feature films, Saurabh, as a creative person, has touched a vast horizon which also includes being Author of three books, Singer, Lyricist and Music Composer of few music albums and poetry albums. He also runs a musical group service "Sunshine", which performs musical programs in charitable organizations like old age homes, orphanages, blind women homes, spastic societies etc.',
    // image: SaurabhSengupta,
  },
  {
    name: 'Meena Jangla',
    designation: 'Director',
    bio: 'On the professional front, she holds a long period of work as an owner of a marriage beureau. And simultaneously, at a personal level, she has always been sincerely involved in activities directed towards welfare of the underprivileged. She is also an active participant in "Sunshine", a musical group which performs musical programs in charitable organizations.',
    image: teamMeena,
  },
  {
    name: 'Advocate GC Singh',
    designation: 'Legal Head',
    bio: 'High Court Lawyer',
    image: advocateGCSingh,
  },
  {
    name: 'Navdeep Kaur',
    designation: 'Brand Ambassador',
    bio: 'Drugs Control Officer from Punjab and Mrs. India Supranational Winner',
    image: teamNavdeepKaur,
  },
  {
    name: 'Arundhati Sengupta',
    designation: 'Torchbearer',
    bio: 'Arundhati Sengupta has 38 years of service at a public sector bank, Punjab National Bank, and retired as Manager in 2016. Executive committee member of "Alapini Mahila Samity", an over hundred years old women\'s social welfare association founded in 1916 in Santiniketan at the behest of Gurudev Rabindranath Tagore by his family members, and on the editorial board of "Shreyasi", the annual magazine and mouthpiece of Alapini.',
    image: arundhati,
  },
  {
    name: 'JOYOSHREE ARORA',
    designation: 'Voice of the Mission',
    bio: 'Joyoshree Arora is a veteran Indian actress best known for her work in iconic Hindi television serials such as Hum Log and Buniyaad. She has also appeared in films including Chak De! India. She has had a long career spanning television, theatre, and films, and is known for portraying strong maternal and grandmotherly characters. In recent years, she played the lively “Baby Maurya” in Sab Satrangi on Sony SAB. With a career that has spanned over four decades, Joyoshree Arora has become a beloved figure in Indian entertainment.',
    image: JOYOSHREE_ARORA,
  },
  {
    name: 'Rahul Hans',
    designation: 'UPHOLDER',
    bio: 'Artist',
    image: rahul,
  },
  {
    name: 'Subrato Singh',
    designation: 'Audio-Visual Head',
    bio: ' Master in Film and TV, Bachelor in Animation, Worked as Filmmaker,  Editor and Cinematograher.',
    image: teamSubrato,
  },
  {
    name: '',
    designation: 'Entertainment Head',
    bio: ' Accomplished Choreographer and Actor',
    image: EntertainmentHead,
  },
  {
    name: 'Jay Kumar Yadav',
    designation: 'Manager',
    bio: 'Belonging to a modest village background in Prayag Raj, he has learnt each and everything needed to handle, manage, execute and supervise with great expertise.',
    image: teamJayKumarYadav,
  },
  
];

const AboutTeam = () => {
  return (
    <section className="bg-white px-6 py-14 md:px-12">
      <div className="mx-auto max-w-6xl">
        <h2 className="mb-8 text-center text-3xl font-bold text-accent md:text-4xl">
          OUR TEAM
        </h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {teamMembers.map((member) => (
            <article
              key={member.name}
              className="overflow-hidden rounded-2xl bg-white shadow-md"
            >
              <img
                src={member.image ?? personImage}
                alt={member.name}
                className="aspect-square w-full object-cover"
              />
              <div className="p-5 text-center">
                <h3 className="text-xl font-semibold text-primary">
                  {member.name}
                  <span className="text-base font-medium uppercase tracking-wide text-gray-600">
                    {' - '}
                    {member.designation}
                  </span>
                </h3>
                {member.bio ? (
                  <p className="mt-3 text-left text-sm leading-relaxed text-gray-600">
                    {member.bio}
                  </p>
                ) : null}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutTeam;
